export class SchematicDrawObject {
    topFt: number;
    topPx: number;
    bottomFt: number;
    bottomPx: number;
    startsBeforeKickpoint: boolean;
    endsBeforeKickpoint: boolean;
    startsAfterKickpoint: boolean;
    endsAfterKickpoint: boolean;
    firstDiagramKickpoint: number;
    startPx: number;
    endPx: number;
    shoeDepthFt: number;
    casingDiameter: number;
    boreholeDiameter: number;
    casingType: string; 
    segmentIndex: number;
    casingLength: number;
    boreholeDepth: number;
    cementTop: number;
    cementVolume: number;
}